import axios from "axios";

const BASE_URL = window.location.href.startsWith('http://localhost') ? 'http://localhost:3000' : 'https://api.emars.fr'

export const publicRequest = axios.create({
    baseURL: BASE_URL
})

